import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations as base } from "@/i18n/translations";
import { faqEn, faqBg } from "@/i18n/faq";
import { withTrackStatus } from "@/config/trackStatus";

// Override FAQ section with the full karting-bg.com content
base.en.faq = faqEn;
base.bg.faq = faqBg;

// Closure overrides are derived; original translations remain available for reopening.
export const translations = {
  en: withTrackStatus(base.en, "en"),
  bg: withTrackStatus(base.bg, "bg"),
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("kartingLang") || "en";
  });

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "en" ? "bg" : "en";
      try { localStorage.setItem("kartingLang", next); } catch (e) { /* ignore */ }
      return next;
    });
  }, []);

  const value = useMemo(
    () => ({ lang, setLang, toggle, t: translations[lang] }),
    [lang, toggle]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
